const dogwood_gold = "#E6BB51";
const foreground = "#d4f0fe";
const background = "rgb(1,53,79)";
const accent1 = "#ffffff";
const accent2 = "#ffffff";
const accent3 = "#9ed3f8";

export { foreground, background, accent1, accent2, accent3, dogwood_gold };
